import React from "react";
import "./recent-blog.scss";
import ArrowLink from "components/arrow-link";
import WaveUnderline from "components/wave-underline";
import NewsList from "components/news-list";
import useMoreBlog from "../../components/more-blog/useMoreBlog";

const RecentBlog = ({ heading, label, linkTo }) => {
  const { data } = useMoreBlog();

  return (
    <div className="RecentBlog">
      <div className="RecentBlog-label">{label}</div>
      <div className="RecentBlog-heading">
        <WaveUnderline>{heading}</WaveUnderline>
      </div>
      <div className="RecentBlog-items">
        {data && <NewsList items={data.entries} />}
      </div>
      <div className="RecentBlog-link">
        <ArrowLink linkTo={linkTo} />
      </div>
    </div>
  );
};

export default RecentBlog;
